import * as React from 'react';

import { FavoriteEntity } from '../../components/FavoriteEntity';
import { CheckboxContainer } from '../CheckboxContainer/CheckboxContainer';
import { useSelector } from 'react-redux';
import { selectOptions } from '../../selectors/print';
import { IFavoriteEntity } from '../../types/results';
import { selectIsEntitySelected } from '../../selectors/selected';

export interface IProps {
  favoriteEntity: IFavoriteEntity;
  isEditComment: boolean;
  isFetchingComment: boolean;
}

export function FavoriteEntityContainer(props: IProps) {
  const { favoriteEntity } = props;
  const { entityId, entityType } = favoriteEntity;
  const isHideForPrint = useSelector(selectIsEntitySelected(entityId, entityType));
  const printOptions = useSelector(selectOptions);

  return (
    <FavoriteEntity
      {...props}
      isHideForPrint={!isHideForPrint}
      printComments={printOptions.printNotes}
      checkbox={<CheckboxContainer favoriteEntity={favoriteEntity} />}
    />
  );
}
